export const UPLOAD_TOAST_DURATION_MS = 4000
export const UPLOAD_NOTE_TOAST_DURATION_MS = 6500

export const canEditAttachmentNotes = (hasFilesEdit: boolean): boolean => hasFilesEdit

export const hasAttachmentNote = (notes: string | null | undefined): boolean =>
  Boolean(notes?.trim())

export const getAttachmentNoteTooltipContent = (
  notes: string | null | undefined,
  emptyCopy: string
): string => {
  const trimmed = notes?.trim()
  return trimmed || emptyCopy
}

export type UploadNoteToastState = 'collapsed' | 'expanded' | 'saving'

export type UploadNoteToastAction =
  | { type: 'ADD_NOTE' }
  | { type: 'CANCEL' }
  | { type: 'SAVE' }
  | { type: 'SAVE_FAILED' }

export const uploadNoteToastReducer = (
  state: UploadNoteToastState,
  action: UploadNoteToastAction
): UploadNoteToastState => {
  switch (action.type) {
    case 'ADD_NOTE':
      return state === 'collapsed' ? 'expanded' : state
    case 'CANCEL':
      return state === 'expanded' || state === 'saving' ? 'collapsed' : state
    case 'SAVE':
      return state === 'expanded' ? 'saving' : state
    case 'SAVE_FAILED':
      return state === 'saving' ? 'expanded' : state
    default:
      return state
  }
}
